var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clientes"},[(_vm.cliente)?_c('clientes-form',{attrs:{"clienteProp":_vm.cliente}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }